import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dropdownContainer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "15px",
    },
    container: {
        width: "90%",
        margin: "0 auto",
    },
}));
